import React, { FC, lazy } from 'react';

import { AxiosError } from 'axios';
import { ErrorBoundary } from 'react-error-boundary';
import { Navigate } from 'react-router-dom';

import EAppRoute from '@/types/appRoutes';

const ErrorPageLazy = lazy(() =>
	import('@/pages').then((module) => ({ default: module.ErrorPage })),
);

type TErrorBoundaryWrapperProps = {
	children?: React.ReactNode;
};

export const ErrorBoundaryWrapper: FC<TErrorBoundaryWrapperProps> = ({ children }) => {
	return (
		<ErrorBoundary
			fallbackRender={({ error }) => {
				if (error instanceof AxiosError) {
					if (
						error.config?.url?.split('/').includes('partners') &&
						error.response?.status === 404
					) {
						return <Navigate to={EAppRoute.NotFound} replace />;
					}
				}

				return <ErrorPageLazy />;
			}}
		>
			{children}
		</ErrorBoundary>
	);
};
